import * as React from 'react';

interface ExpireProps {
    delay?: number,
}
interface ExpireState {
    delay?: number,
    visible: boolean,
}
class Expire extends React.Component<ExpireProps, ExpireState> {
    constructor(props) {
        super(props);
        this.state = {
            delay: null,
            visible: true
        };
    }

    timer: NodeJS.Timer;

    componentDidUpdate(prevProps) {
        // reset the timer if children are changed
        if (this.props.children !== prevProps.children && this.props.delay) {
            this.setTimer();
            this.setState({ visible: true });
        }
    }

    componentDidMount() {
        if (this.props.delay) {
            this.setTimer();
        }
    }
    setTimer() {
      // clear any existing timer
      this.timer != null ? clearTimeout(this.timer) : null;

      // hide after `delay` milliseconds
      this.timer = setTimeout(() => {
        this.setState({ visible: false });
        this.timer = null;
      }, this.props.delay);
    }
    componentWillUnmount() {
      clearTimeout(this.timer);
    }
    render() {
      return this.state.visible
             ? <>{this.props.children}</>
             : null;
    }
}

export default Expire;



// WEBPACK FOOTER //
// ./src/components/Expire.tsx